import React from 'react';
import pt from 'prop-types';
import Status from 'components/status';

export default function PartnerPayoutStatus({
  partner,
  blank = false,
  dot = true,
}) {
  const enabled = Boolean(partner?.payout_account?.enabled);

  return (
    <Status type={enabled ? 'positive' : 'muted'} blank={blank} dot={dot}>
      {enabled ? 'Enabled' : 'Disabled'}
    </Status>
  );
}

PartnerPayoutStatus.propTypes = {
  partner: pt.object,
  blank: pt.bool,
  dot: pt.bool,
};
